<template>
  <article class="performer-event-item" @click="onClickEvent">
    <div class="performer-event-item-img">
      <img :src="eventImgUrl" :alt="title">
    </div>
    <div class="performer-event-item-info">
      <h3 class="performer-event-item-info-title">
        {{ title }}
      </h3>
      <p class="performer-event-item-info-detail">
        {{ schedule }} 開催
      </p>
      <p class="performer-event-item-info-detail performers">
        {{ performers }}
      </p>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    eventImgUrl: {
      type: String
    },
    title: {
      type: String
    },
    schedule: {
      type: String
    },
    performers: {
      type: String
    }
  },
  methods: {
    onClickEvent: function () {
      this.$emit('onClickEvent')
    }
  }
}
</script>

<style lang="scss" scoped>
$breakpoint: 767px;

.performer-event-item {
  display: flex;
  cursor: pointer;
  transition: .2s;

  &:hover {
    opacity: 0.7;
  }
  .performer-event-item {
    &-img {
      margin-right: 20px;
      img {
        object-fit: cover;
        width: 130px;
        height: 130px;

        @media screen and (max-width: $breakpoint) {
          width: 80px;
          height: 80px;
        }
      }
    }
    &-info {
      width: calc(100% - 130px);

      @media screen and (max-width: $breakpoint) {
        width: calc(100% - 80px);
      }
      &-title {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
        color: #333;
        text-align: left;
        padding-bottom: 0;

        @media screen and (max-width: $breakpoint) {
          font-size: 13px;
          margin-bottom: 5px;
          display: -webkit-box;
          overflow: hidden;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      &-detail {
        color: #666;
        font-size: 13px;
        margin-bottom: 10px;

        @media screen and (max-width: $breakpoint) {
          margin-bottom: 5px;
        }

        &.performers {
          @media screen and (max-width: $breakpoint) {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding-right: 2rem;
          }
        }
      }
    }
  }
}
</style>
